var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "camContainerLive" } }, [
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.listCamCeiba.length > 0,
          expression: "listCamCeiba.length > 0"
        }
      ],
      staticStyle: { width: "100%", height: "100%", background: "#003" },
      attrs: { id: "div_video" }
    }),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.listCamCms6.length > 0,
            expression: "listCamCms6.length > 0"
          }
        ],
        staticStyle: { height: "100%", width: "100%" },
        attrs: { id: "camContainerLiveAncient" }
      },
      [
        _c(
          "div",
          {
            staticStyle: { height: "100%", width: "100%" },
            attrs: { id: "ancientCameras" }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "background-color": "rgb(245 245 245)",
                  height: "28px",
                  width: "100%",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(
                    "\n          Canales: (" +
                      _vm._s(_vm.listCamCms6.length) +
                      " / " +
                      _vm._s(_vm.limitAncientCams) +
                      ")\n        "
                  )
                ])
              ]
            ),
            _c("div", {
              staticStyle: { "background-color": "white", height: "96%" },
              attrs: { id: "cmsv6flash" }
            })
          ]
        )
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.listCamNuevo.length > 0,
            expression: "listCamNuevo.length > 0"
          }
        ],
        staticClass: "grid",
        attrs: { id: "gridCams" }
      },
      _vm._l(_vm.listCamFill, function(cam) {
        return _c(
          "div",
          {
            key: cam.id,
            staticClass: "player",
            attrs: { id: "player" + cam.id }
          },
          [
            !cam.background
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      margin: "0 auto",
                      "background-color": "#020202"
                    },
                    attrs: { id: "containerds" }
                  },
                  [
                    _c("video", {
                      staticStyle: { height: "calc(100% - 20px)" },
                      attrs: {
                        width: "100%",
                        controls: "",
                        autoplay: "",
                        muted: "",
                        id: "playerVideo" + cam.id
                      },
                      domProps: { muted: true }
                    }),
                    _c("div", { staticClass: "footerCam" }, [
                      _c(
                        "div",
                        {
                          staticClass: "btnFooter",
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            width: "100%"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "white",
                                "margin-left": "15px"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(cam.patent) +
                                  "-CH" +
                                  _vm._s(cam.name) +
                                  "-" +
                                  _vm._s(cam.id_camara) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              : _c("img", {
                  staticClass: "backgroundfill",
                  attrs: { src: require("@/assets/tv_default.jpg") }
                })
          ]
        )
      }),
      0
    ),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.listCamHowenVss.length > 0,
          expression: "listCamHowenVss.length > 0"
        }
      ],
      staticStyle: {
        height: "100%",
        width: "100%",
        "box-sizing": "border-box",
        background: "#dcdcdc",
        margin: "auto",
        "box-shadow": "50px 50px white"
      },
      attrs: { id: "test" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }